import React from 'react'
import Box from '../components/Box'

export default function Section10() {
    return (
        <div className="section">
            <h2>Section X: Importing Scores</h2>
            <Box sectionData={'start'} title={'Step 1: Create the Files to Import'} body={`Scores can be imported from properly formatted comma separated value files with a .gbs extension.
            Create this file as follows:
            1. Using a standard text editor such as TextEdit on OS X or Notepad on Windows create a blank
            plain text file.
            2. Begin by creating a header row as follows:
            ID,LastName,FirstName,Score
            a. There should be exactly three commas on each row. If there are more or less the row
            will be ignored.
            3. Enter a newline (enter or return) at the end of each row. The last line should be blank.
            4. Save the file with a .gbs extension to a known location.
            Notes:
            • A spreadsheet editor may be used to create the .csv file but care must be taken that exactly
            four columns are created. Create one column for each entry in the header defined above.
            Name the columns according to the header specified above (the first column should contain
            ‘ID”, etc...
            • The import function will match the score to the appropriate student with a numerical (not text)
            match of the student ID. If no student ID match is made the importer will attempt to match the
            student name (both first and last name must match).
            • Apperson DataLink will create properly formatted files if you select “GradeBook Pro” in the
            Preferences -> Gradebook menu.`} />



            <Box title={'Step 2: Copy the Files to the iOS Device'} body={`Note: Files can be selected without being first copied to the device. Create the file as directed in step
            1 and place the file in a location accessible from within an iOS document picker extension (iCloud
            Drive, Dropbox, Google Drive, and Box are popular examples). Skip to step 3 and select ‘Other...’
            from the ‘Import’ menu.
            Files may be copied to the device using one of the two following methods before proceeding to step
            3.
            To transfer the files with Dropbox:
            1. Login to Dropbox from GradeBook Pro on the destination iOS Device. This will create a
            directory in your Dropbox at /GradeBook Pro/Import/Scores/
            2. Copy the files to be imported to the directory created in step 1.
            3. On the “Data” screen, tap “Download Score Import Files”. This will copy the files placed in the
            directory to the /Documents directory of GradeBook Pro.
            To transfer the files via email:
            1. Email the file(s) to an email address accessible on the destination iOS Device.
            2. Open the email on the iOS Device.
            3. Tap the file and then “Open in GradeBook Pro”.
            4. The file will be sent to GradeBook Pro and is ready to be imported to an assignment`} />

            <Box sectionData={'end'} title={'Step 3: Import the Scores:'} body={`The files are now ready to be imported to the class roster of choice by following the procedure
            outlined in Section V (Import Scores).`} />
        </div>
    )
}